import {Directive, Input} from '@angular/core';

@Directive()
export abstract class InputComponent<T> {

    @Input()
    public inputOptions: T | undefined;

    @Input()
    public inputComponentFocus: boolean | undefined;

    /** The input options for code paths that cannot work without them; the bot sends them for every input type but 'none'. */
    protected requireInputOptions(): T {
        if (this.inputOptions === undefined) {
            throw new Error('The input options are missing');
        }
        return this.inputOptions;
    }

}
